module.exports = __webpack_public_path__ + "img/utilityvalve_parked.614d03b4.svg";